import { Avatar } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import { useVideo } from '../../api/VideoProvider';
import { pRecordTime, pStatus } from '../../utils/parameters';
import { useTranslation } from "react-i18next";
import { useTimerProvider } from "../../api/TimerProvider";


export function CountdownTimer(props) {
    const { t } = useTranslation("global")
    const { timer } = useTimerProvider();
    
    return (
        <>
            <div className={`sig_Home_CountdownContainer`}>
                <p className='sig_Home_CountdownTitle'> {t("sRecordComponent.recording_in")} </p>
                <Avatar className='sig_Home_Countdown'>{Math.max(0, timer - 1)}</Avatar>
            </div>
        </>
    );
}